import { ResourceFilterConfig } from '../types/filterTypes';

// Interaction filters configuration
export const interactionFilters: ResourceFilterConfig = {
  resourceName: 'Interactions',
  filters: [
    {
      key: 'team',
      label: 'Team',
      type: 'string',
      placeholder: 'Team name'
    },
    {
      key: 'agent',
      label: 'Agent',
      type: 'string',
      placeholder: 'Agent name'
    },
    {
      key: '_all_evals',
      label: 'All Evaluations',
      type: 'string',
      placeholder: 'False',
    },
    // Date-related filters
    {
      key: 'date',
      label: 'Date',
      type: 'string', // Plain string type
      groupId: 'date'
    },
    {
      key: 'date_min',
      label: 'Date From',
      type: 'date', // Date type
      groupId: 'date'
    },
    {
      key: 'date_max',
      label: 'Date To',
      type: 'date', // Date type
      groupId: 'date'
    },
    // Time-related filters
    {
      key: 'time',
      label: 'Time',
      type: 'string', // Plain string type
      groupId: 'time'
    },
    {
      key: 'time_min',
      label: 'Time From',
      type: 'time', // Time type
      groupId: 'time'
    },
    {
      key: 'time_max',
      label: 'Time To',
      type: 'time', // Time type
      groupId: 'time'
    },
    // Other filters
    {
      key: 'transcription_keywords',
      label: 'Transcription Keywords',
      type: 'string',
      isMultiValue: true,
      placeholder: 'Enter keyword'
    },
    {
      key: 'moments',
      label: 'Moments',
      type: 'string',
      isMultiValue: true,
      placeholder: 'Enter moment'
    },
    {
      key: 'duration',
      label: 'Duration',
      type: 'number',
      groupId: 'duration'
    },
    {
      key: 'duration_min',
      label: 'Duration Min',
      type: 'number',
      placeholder: 'Min seconds',
      groupId: 'duration'
    },
    {
      key: 'duration_max',
      label: 'Duration Max',
      type: 'number',
      placeholder: 'Max seconds',
      groupId: 'duration'
    }
  ],
  groups: [
    {
      id: 'date',
      label: 'Date',
      defaultMode: 'simple'
    },
    {
      id: 'time',
      label: 'Time',
      defaultMode: 'simple'
    },
    {
      id: 'duration',
      label: 'Call Duration',
      defaultMode: 'simple'
    }
  ]
};

// Moment filters configuration
export const momentFilters: ResourceFilterConfig = {
  resourceName: 'Moments',
  filters: [
    {
      key: 'id',
      label: 'ID',
      type: 'number',
      placeholder: 'Moment ID'
    },
    {
      key: 'name',
      label: 'Name',
      type: 'string',
      placeholder: 'Moment name'
    },
    {
      key: 'status',
      label: 'Status',
      type: 'enum',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
      ],
      placeholder: 'Select status'
    },
    {
      key: 'prompt',
      label: 'Prompt',
      type: 'string',
      placeholder: 'Search in prompt text',
      isMultiValue: true
    },
    {
      key: 'occurrence_id',
      label: 'Occurrence',
      type: 'enum',
      placeholder: 'Select occurrence',
      // Options will be populated dynamically from API
      dynamicOptions: true
    },
    {
      key: 'language_id',
      label: 'Language',
      type: 'enum',
      placeholder: 'Select language',
      // Options will be populated dynamically from API
      dynamicOptions: true
    },
    {
      key: 'sentiment_id',
      label: 'Sentiment',
      type: 'enum',
      placeholder: 'Select sentiment',
      // Options will be populated dynamically from API
      dynamicOptions: true
    },
    {
      key: 'speaker_id',
      label: 'Speaker',
      type: 'enum',
      placeholder: 'Select speaker',
      // Options will be populated dynamically from API
      dynamicOptions: true
    },
    {
      key: 'search_method_id',
      label: 'Search Method',
      type: 'enum',
      placeholder: 'Select search method',
      // Options will be populated dynamically from API
      dynamicOptions: true
    },
    {
      key: 'search',
      label: 'search',
      type: 'string',
      isMultiValue: true,
      placeholder: 'Search by name or prompt or examples'
    },
  ],
  groups: []
}; 

export const utteranceFilters: ResourceFilterConfig = {
  resourceName: 'Utterance Sources',
  filters: [
    {
      key: 'utsid',
      label: 'Source ID',
      type: 'number',
      placeholder: 'Source ID'
    },
    {
      key: 'name',
      label: 'Name',
      type: 'string',
      placeholder: 'Source name'
    },
    {
      key: 'source',
      label: 'Source Tag',
      type: 'string',
      placeholder: 'Source tag'
    },
    {
      key: 'intent_annotation',
      label: 'Has Intent Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'entity_annotation',
      label: 'Has Entity Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'mmt_annotation',
      label: 'Has Moment Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'date',
      label: 'Sourcing Date',
      type: 'date',
      groupId: 'date'
    },
    {
      key: 'date_min',
      label: 'Sourcing Date From',
      type: 'date',
      groupId: 'date'
    },
    {
      key: 'date_max',
      label: 'Sourcing Date To',
      type: 'date',
      groupId: 'date'
    },
    {
      key: 'time',
      label: 'Sourcing Time',
      type: 'time',
      groupId: 'time'
    },
    {
      key: 'time_min',
      label: 'Sourcing Time From',
      type: 'time',
      groupId: 'time'
    },
    {
      key: 'time_max',
      label: 'Sourcing Time To',
      type: 'time',
      groupId: 'time'
    }
  ],
  groups: [
    { id: 'date', label: 'Date', defaultMode: 'simple' },
    { id: 'time', label: 'Time', defaultMode: 'simple' }
  ]
};

export const utteranceDetailFilters: ResourceFilterConfig = {
  resourceName: 'Utterances',
  filters: [
    {
      key: 'utid',
      label: 'Utterance ID',
      type: 'number',
      placeholder: 'Specific utterance ID'
    },
    {
      key: 'executions',
      label: 'Include Executions',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'execttool_name',
      label: 'Execution Tool',
      type: 'string',
      placeholder: 'Tool name'
    },
    {
      key: 'execution_date',
      label: 'Execution Date',
      type: 'date',
      groupId: 'execution_date'
    },
    {
      key: 'execution_date_min',
      label: 'Execution Date From',
      type: 'date',
      groupId: 'execution_date'
    },
    {
      key: 'execution_date_max',
      label: 'Execution Date To',
      type: 'date',
      groupId: 'execution_date'
    },
    {
      key: 'execution_time',
      label: 'Execution Time',
      type: 'time',
      groupId: 'execution_time'
    },
    {
      key: 'execution_time_min',
      label: 'Execution Time From',
      type: 'time',
      groupId: 'execution_time'
    },
    {
      key: 'execution_time_max',
      label: 'Execution Time To',
      type: 'time',
      groupId: 'execution_time'
    },
    {
      key: 'intent_annotation',
      label: 'Include Intent Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'entity_annotation',
      label: 'Include Entity Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    },
    {
      key: 'mmt_annotation',
      label: 'Include Moment Annotations',
      type: 'enum',
      options: [
        { value: 'True', label: 'Yes' },
        { value: 'False', label: 'No' }
      ]
    }
  ],
  groups: [
    { id: 'execution_date', label: 'Execution Date', defaultMode: 'simple' },
    { id: 'execution_time', label: 'Execution Time', defaultMode: 'simple' }
  ]
};